// Fill colour for a host-resource meter on /admin/host-stats. Mint while
// there's comfortable headroom, amber once the resource is getting busy,
// coral when it's nearly exhausted. The meter always prints its value as
// text too, so colour is never the only signal.
export const HOST_METER_BUSY_PERCENT = 70
export const HOST_METER_CRITICAL_PERCENT = 90

export function hostMeterTone(percent: number | null): string {
  if (percent == null) return 'bg-brand-primary'
  if (percent >= HOST_METER_CRITICAL_PERCENT) return 'bg-status-alert'
  if (percent >= HOST_METER_BUSY_PERCENT) return 'bg-factory'
  return 'bg-brand-primary'
}

// used / total as a 0–100 percentage; null when either side is unknown
// (an unreadable /host_proc) or the total is zero.
export function hostUsagePercent(used: number | null, total: number | null): number | null {
  if (used == null || total == null || total <= 0) return null
  return Math.min(100, Math.max(0, (used / total) * 100))
}
